"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_13_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 75.13.0
 *
 * Add missing ArticleSpecs for child Ketten
 *
 */
const setArticleSpec = (json, posNo, pos) => {
    var _a, _b, _c, _d;
    if (json.Children && !((_c = (_b = (_a = json.Children[posNo]) === null || _a === void 0 ? void 0 : _a.Kette) === null || _b === void 0 ? void 0 : _b.ArticleSpecs) === null || _c === void 0 ? void 0 : _c.includes(pos))) {
        if (Array.isArray(json.Children[posNo].Kette.ArticleSpecs)) {
            (_d = json.Children[posNo].Kette.ArticleSpecs) === null || _d === void 0 ? void 0 : _d.push(pos);
        }
        else {
            json.Children[posNo].Kette.ArticleSpecs = [pos];
        }
    }
    return json;
};
const migration_75_13_0 = (json) => {
    var _a, _b, _c;
    if (json.Espool) {
        if (((_a = json.Children) === null || _a === void 0 ? void 0 : _a.length) === 2) {
            if (json.Children && json.Children[0].Kette) {
                json = setArticleSpec(json, 0, echain_shared_articles_1.EspoolChainPosition.linear);
            }
            if (json.Children && json.Children[1].Kette) {
                const spec = ((_b = json.Espool) === null || _b === void 0 ? void 0 : _b.LeftKette) ? echain_shared_articles_1.EspoolChainPosition.left : echain_shared_articles_1.EspoolChainPosition.right;
                json = setArticleSpec(json, 1, spec);
            }
        }
        if (((_c = json.Children) === null || _c === void 0 ? void 0 : _c.length) === 3) {
            if (json.Children && json.Children[0].Kette) {
                json = setArticleSpec(json, 0, echain_shared_articles_1.EspoolChainPosition.linear);
            }
            if (json.Children && json.Children[1].Kette) {
                json = setArticleSpec(json, 1, echain_shared_articles_1.EspoolChainPosition.left);
            }
            if (json.Children && json.Children[2].Kette) {
                json = setArticleSpec(json, 2, echain_shared_articles_1.EspoolChainPosition.right);
            }
        }
    }
    return json;
};
exports.migration_75_13_0 = migration_75_13_0;
//# sourceMappingURL=migration_75_13_0.js.map